module.exports = __webpack_public_path__ + "img/victron_smart_24_12_30.38fbc8da.png";